module.exports = JSON.parse("{\"timestamp\":\"21.10.2026 - 23:50:33\",\"brands\":[]}")